import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/Home/banner-1.png';
import _imports_1 from '../../assets/img/Home/icon1.png';
import _imports_2 from '../../assets/img/Home/gate.png';
import _imports_3 from '../../assets/img/Home/icon7.png';
import _imports_4 from '../../assets/img/Home/icon6.png';
import _imports_5 from '../../assets/img/Home/line1.png';
import _imports_6 from '../../assets/img/Home/line2.png';
import _imports_7 from '../../assets/img/Home/h5-line1.png';
import _imports_8 from '../../assets/img/Home/h5-line2.png';
import _imports_9 from '../../assets/img/Home/icon3.png';
import _imports_10 from '../../assets/img/Home/icon8.png';
import _imports_11 from '../../assets/img/Home/icon4.png';
import _imports_12 from '../../assets/img/Home/icon5.png';
import _imports_13 from '../../assets/img/Home/icon2.png';
import _imports_14 from '../../assets/img/Home/being.png';
import _imports_15 from '../../assets/img/Home/supe-ai.png';
const _withScopeId = n => (_pushScopeId("data-v-191d512c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "banner"
};
const _hoisted_2 = {
  class: "main w1200"
};
const _hoisted_3 = {
  class: "web3-future"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "_", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_7 = {
  class: "web3-token"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = {
  class: "eeg-real-time-data w1000"
};
const _hoisted_11 = {
  class: "eeg-address"
};
const _hoisted_12 = {
  class: "address"
};
const _hoisted_13 = {
  class: "copy"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "single-line-ellipsis"
}, "0x663C51ff62632b72aa794b14e4aD452bf1847a57", -1));
const _hoisted_15 = {
  href: "https://www.gate.io/zh/trade/EEG_USDT",
  target: "_blank"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_17 = ["data-lang"];
const _hoisted_18 = {
  class: "main w1000"
};
const _hoisted_19 = {
  class: "content1"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "",
  class: "logo"
}, null, -1));
const _hoisted_21 = {
  class: "arrow"
};
const _hoisted_22 = {
  class: "content2"
};
const _hoisted_23 = {
  class: "eeg-operation-mechanism"
};
const _hoisted_24 = {
  class: "main w1200"
};
const _hoisted_25 = {
  class: "content1 w1000"
};
const _hoisted_26 = {
  class: "outer-ul"
};
const _hoisted_27 = {
  class: "li"
};
const _hoisted_28 = {
  class: "inter-ul"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
})], -1));
const _hoisted_30 = {
  class: "li"
};
const _hoisted_31 = {
  class: "inter-ul pc-ul"
};
const _hoisted_32 = {
  class: "inter-ul h5-ul"
};
const _hoisted_33 = {
  class: "content2"
};
const _hoisted_34 = {
  class: "ul1"
};
const _hoisted_35 = {
  class: "pc-ul2"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "line line1",
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "line line2",
  src: _imports_6,
  alt: ""
}, null, -1));
const _hoisted_38 = {
  class: "h5-ul2"
};
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "line line1",
  src: _imports_7,
  alt: ""
}, null, -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "line line2",
  src: _imports_8,
  alt: ""
}, null, -1));
const _hoisted_41 = {
  class: "content3 w1000"
};
const _hoisted_42 = {
  class: "ul1"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  alt: ""
}, null, -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  alt: ""
}, null, -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  alt: ""
}, null, -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  alt: ""
}, null, -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  alt: ""
}, null, -1));
const _hoisted_48 = {
  class: "ul2"
};
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_50 = {
  class: "eeg-partner"
};
const _hoisted_51 = {
  class: "main w1200"
};
const _hoisted_52 = {
  class: "websites"
};
const _hoisted_53 = {
  href: "https://being.com",
  target: "_blank"
};
const _hoisted_54 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  alt: ""
}, null, -1));
const _hoisted_55 = {
  href: "https://supe.ai",
  target: "_blank"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  alt: ""
}, null, -1));
import { ref, onMounted, computed, getCurrentInstance, watch, nextTick } from "vue";
import { initContractsPrice } from "@/utils/binance/price";
import BigNumber from "bignumber.js";
import { useStore } from "vuex";
import { copyText, addCommasToNumber } from "@/utils";
import { useI18n } from "vue-i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
export default {
  __name: 'index',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const store = useStore();
    const lang = computed(() => {
      return store.state.lang;
    });
    const {
      t
    } = useI18n();
    const eegTotal = ref(0);
    const eegPrice = ref(0);
    const eegTotalValue = ref(0);
    const textElement1 = ref(null);
    const textElement2 = ref(null);
    const textElement3 = ref(null);
    getEEG();
    onMounted(() => {});
    function getEegPrice() {
      return new Promise((resolve, reject) => {
        proxy.$api.coinPrice({
          crypto: "EEG"
        }).then(res => {
          if (!res.error_code) {
            resolve(res.data);
          } else {
            resolve(0);
          }
        }).catch(() => {
          reject(0);
        });
      });
    }
    function getEegTatol() {
      return new Promise((resolve, reject) => {
        initContractsPrice().eeg.erc20.methods.totalSupply().call().then(res => {
          resolve(new BigNumber(res).div(1e18));
        }).catch(() => {
          reject(0);
        });
      });
    }
    function getEEG() {
      Promise.all([getEegPrice(), getEegTatol()]).then(res => {
        eegPrice.value = Number(res[0].price);
        eegTotal.value = Number(res[1]);
        eegTotalValue.value = new BigNumber(eegPrice.value).times(new BigNumber(eegTotal.value)).dp(0).toNumber();
      }).catch(() => {});
    }
    watch(() => eegTotal.value, async () => {
      await nextTick();
      setTimeout(() => {
        adjustFontSize(textElement1.value);
      }, 0);
    });
    watch(() => eegPrice.value, async () => {
      await nextTick();
      setTimeout(() => {
        adjustFontSize(textElement2.value);
      }, 0);
    });
    watch(() => eegTotalValue.value, async () => {
      await nextTick();
      setTimeout(() => {
        adjustFontSize(textElement3.value);
      }, 0);
    });
    function adjustFontSize(textElements) {
      if (textElements) {
        const containerWidth = textElements.parentNode.offsetWidth;
        const textWidth = textElements.clientWidth;
        var scale = 1;
        if (textWidth >= containerWidth) {
          scale = containerWidth / (textWidth + 50);
        } else {
          scale = 1;
        }
        textElements.style.transform = `scale(${scale})`;
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['home-index', 'home-index-' + _unref(lang)])
      }, [_createVNode(_unref(Header)), _createElementVNode("section", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, [_createTextVNode(_toDisplayString(_unref(t)("home.text1")), 1), _hoisted_5]), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text2")), 1)]), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text3")), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text4")), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text5")), 1)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text6")), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("span", {
        ref_key: "textElement1",
        ref: textElement1
      }, _toDisplayString(_unref(addCommasToNumber)(eegTotal.value)), 513), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text7")), 1)]), _createElementVNode("li", null, [_createElementVNode("span", {
        ref_key: "textElement2",
        ref: textElement2
      }, _toDisplayString(_unref(addCommasToNumber)(eegPrice.value)), 513), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text8")), 1)]), _createElementVNode("li", null, [_createElementVNode("span", {
        ref_key: "textElement3",
        ref: textElement3
      }, _toDisplayString(_unref(addCommasToNumber)(eegTotalValue.value)), 513), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text9")), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text10")), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = $event => _unref(copyText)('0x663C51ff62632b72aa794b14e4aD452bf1847a57'))
      }, _toDisplayString(_unref(t)("public.copy")), 1)]), _createElementVNode("a", _hoisted_15, [_hoisted_16, _createTextVNode(" " + _toDisplayString(_unref(t)("home.text11")), 1)])])])])])]), _createElementVNode("div", {
        class: "eeg-token-model",
        "data-lang": _unref(lang)
      }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text12")), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text13")), 1), _hoisted_20, _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)("home.text14")), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text15")), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text16")), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text17")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text18")), 1)]), _createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text19")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text20")), 1)])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text21")), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text22")), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text23")), 1), _createElementVNode("p", null, _toDisplayString(_unref(t)("home.text24")), 1)])])], 8, _hoisted_17), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text25")), 1), _createElementVNode("ul", _hoisted_26, [_createElementVNode("li", _hoisted_27, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text26")), 1), _createElementVNode("ul", _hoisted_28, [_createElementVNode("li", null, [_createElementVNode("b", null, _toDisplayString(_unref(t)("home.text27")), 1)]), _hoisted_29, _createElementVNode("li", null, [_createElementVNode("b", null, _toDisplayString(_unref(t)("home.text28")), 1)])])]), _createElementVNode("li", _hoisted_30, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text29")), 1), _createElementVNode("ul", _hoisted_31, [_createElementVNode("li", null, [_createElementVNode("b", null, _toDisplayString(_unref(t)("home.text30")), 1), _createTextVNode(), _createElementVNode("i", null, _toDisplayString(_unref(t)("home.text32")), 1)]), _createElementVNode("li", null, [_createElementVNode("b", null, _toDisplayString(_unref(t)("home.text31")), 1), _createTextVNode(), _createElementVNode("i", null, _toDisplayString(_unref(t)("home.text33")), 1)])]), _createElementVNode("ul", _hoisted_32, [_createElementVNode("li", null, [_createElementVNode("b", null, _toDisplayString(_unref(t)("home.text30")), 1)]), _createElementVNode("li", null, [_createElementVNode("b", null, _toDisplayString(_unref(t)("home.text31")), 1)]), _createElementVNode("li", null, [_createElementVNode("i", null, _toDisplayString(_unref(t)("home.text32")), 1), _createElementVNode("i", null, _toDisplayString(_unref(t)("home.text33")), 1)])])])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text34")), 1), _createElementVNode("ul", _hoisted_34, [_createElementVNode("li", null, _toDisplayString(_unref(t)("home.text35")), 1), _createElementVNode("li", null, _toDisplayString(_unref(t)("home.text36")), 1)]), _createElementVNode("ul", _hoisted_35, [_createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text37")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text38")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text39")), 1)]), _createElementVNode("li", null, [_hoisted_36, _hoisted_37, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text40")), 1)]), _createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text41")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text42")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text43")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text44")), 1)])]), _createElementVNode("ul", _hoisted_38, [_createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text37")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text38")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text39")), 1)]), _createElementVNode("li", null, [_hoisted_39, _hoisted_40, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text40")), 1)]), _createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text41")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text43")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text42")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text44")), 1)])])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text45")), 1), _createElementVNode("ul", _hoisted_42, [_createElementVNode("li", null, [_createElementVNode("div", null, [_hoisted_43, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text46")), 1)])]), _createElementVNode("li", null, [_createElementVNode("div", null, [_hoisted_44, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text47")), 1)]), _createElementVNode("div", null, [_hoisted_45, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text48")), 1)])]), _createElementVNode("li", null, [_createElementVNode("div", null, [_hoisted_46, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text49")), 1)]), _createElementVNode("div", null, [_hoisted_47, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text50")), 1)])])]), _createElementVNode("ul", _hoisted_48, [_createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text51")), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text52")), 1)]), _createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString(_unref(t)("home.text53")), 1), _createElementVNode("span", null, [_createTextVNode(_toDisplayString(_unref(t)("home.text54")), 1), _hoisted_49, _createTextVNode(_toDisplayString(_unref(t)("home.text55")), 1)])])])])])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("p", null, _toDisplayString(_unref(t)("home.text56")), 1), _createElementVNode("div", _hoisted_52, [_createElementVNode("a", _hoisted_53, [_hoisted_54, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text57")), 1)]), _createElementVNode("a", _hoisted_55, [_hoisted_56, _createElementVNode("span", null, _toDisplayString(_unref(t)("home.text58")), 1)])])])])]), _createVNode(_unref(Footer))], 2);
    };
  }
};